import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Box,
} from "@mui/material";

const PlanLoadingShimmer = ({ rows = 3 }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: "1px solid #E2E8F0",
        overflow: "hidden",
      }}
    >
      <TableContainer>
        <Table sx={{ minWidth: 800 }}>
          <TableHead sx={{ bgcolor: "#F8FAFC" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600, color: "#475569" }}>
                Plan
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#475569" }}>
                Monthly
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#475569" }}>
                Annual
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#475569" }}>
                Status
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#475569" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(rows)].map((_, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    bgcolor: "#F8FAFC",
                  },
                }}
              >
                <TableCell>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
                  >
                    <Skeleton
                      variant="text"
                      width={120}
                      height={24}
                      sx={{
                        borderRadius: "4px",
                        bgcolor: "rgba(226, 232, 240, 0.5)",
                        animation: "pulse 1.5s ease-in-out infinite",
                        "@keyframes pulse": {
                          "0%": { opacity: 1 },
                          "50%": { opacity: 0.4 },
                          "100%": { opacity: 1 },
                        },
                      }}
                    />
                    {index === 0 && (
                      <Skeleton
                        variant="text"
                        width={80}
                        height={20}
                        sx={{
                          borderRadius: "4px",
                          bgcolor: "rgba(226, 232, 240, 0.5)",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    )}
                  </Box>
                </TableCell>
                <TableCell>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}
                  >
                    <Skeleton
                      variant="text"
                      width={100}
                      height={24}
                      sx={{
                        borderRadius: "4px",
                        bgcolor: "rgba(226, 232, 240, 0.5)",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                    {index === 1 && (
                      <Skeleton
                        variant="text"
                        width={80}
                        height={20}
                        sx={{
                          borderRadius: "4px",
                          bgcolor: "rgba(226, 232, 240, 0.5)",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    )}
                  </Box>
                </TableCell>
                <TableCell>
                  <Skeleton
                    variant="text"
                    width={100}
                    height={24}
                    sx={{
                      borderRadius: "4px",
                      bgcolor: "rgba(226, 232, 240, 0.5)",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Skeleton
                      variant="rounded"
                      width={36}
                      height={20}
                      sx={{
                        borderRadius: "12px",
                        bgcolor: "rgba(226, 232, 240, 0.5)",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                    <Skeleton
                      variant="text"
                      width={45}
                      height={20}
                      sx={{
                        borderRadius: "4px",
                        bgcolor: "rgba(226, 232, 240, 0.5)",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Skeleton
                    variant="circular"
                    width={32}
                    height={32}
                    sx={{
                      bgcolor: "rgba(226, 232, 240, 0.5)",
                      animation: "pulse 1.5s ease-in-out infinite",
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PlanLoadingShimmer;
